var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDentalBenefitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z",
    fill: "#D9E2FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7 1.03101H22.2778V4.88095L18 4.88095V8.73095H22.2778V12.581H25.7V8.73095H29.9778V4.88095L25.7 4.88095V1.03101Z",
    fill: "#FB6F55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77517 24.9385C8.26101 23.8141 8.3949 18.0573 8.0961 17.0379C7.7973 16.0184 7.25318 15.2988 7.06168 13.8147C7.00171 13.3499 6.73186 11.2211 8.0961 10.3666C9.46034 9.51206 11.0794 10.4715 12.5486 11.2211C14.0178 11.9707 15.0073 11.1162 15.6969 10.7414C16.3865 10.3666 17.1361 9.91685 18.4403 10.2317C20.0149 10.6117 20.0894 12.3013 19.9545 13.7704C19.8196 15.2396 19.3526 16.1384 19.115 17.0379C18.8259 18.1323 18.8451 19.0767 18.2455 21.5354C17.6624 23.9258 17.0161 25.0134 15.8618 25.1933C14.7074 25.3732 14.8274 22.5998 14.8274 21.9701C14.8274 21.3405 14.3626 18.594 13.5831 18.4021C12.6086 18.1623 12.5486 19.0468 12.1289 20.381C11.7091 21.7153 11.2697 26.0483 9.77517 24.9385Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentalBenefitLogo);
export default __webpack_public_path__ + "static/media/DentalBenefitLogo.1b355384135bc3d75e95453bdbc226b4.svg";
export { ForwardRef as ReactComponent };